import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DownloadExcelComponent } from 'src/app/module/shared/components/download-excel/download-excel.component';
import { ViewEditCommonComponent } from 'src/app/module/shared/components/view-edit-common/view-edit-common.component';
import { AccessControlService } from 'src/app/shared/services/AccessControl.service';
import { TabService } from 'src/app/shared/tab.service';
import { AddordersComponent } from '../add-orders/add-orders.component';
import { CommonBulkPrintComponent } from 'src/app/module/shared/components/common-bulk-print/common-bulk-print.component';
import { CommonCsvComponent } from 'src/app/module/shared/components/common-csv/common-csv.component';
import { Observable } from 'rxjs';
import { ordersService } from '../../services/orders.service';
import { NeAddOrderComponent } from '../ne-add-order/ne-add-order.component';
import { AddComponentComponent } from '../add-component/add-component.component';
import { RemoveComponentComponent } from '../remove-component/remove-component.component';
import { ExchangeComponentComponent } from '../exchange-component/exchange-component.component';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css'],
})
export class ordersComponent {
  theme = 'dark';
  pageSize = 100; // Number of items per page
  pageIndex = 0;
  currentPage: number = 0;
  pageNumber = 0;
  sortingCol: string = 'id';
  direction: string = 'DESC';
  tableName = 'orderTable';
  warehouseFilter: any = [];
  warehouseData: any = [];
  getWarehouseList: any;
  customerModel: any;
  selectedWarehouse: any;
  storedWarehouse: any;
  clientId: any;
  clientDetails: any;
  ref: DynamicDialogRef | undefined;
  selectedData: any[] = [];
  editContation: boolean = false;
  // filters= [];
  filters: { key: string; value: any }[] = [];
  userType: any;
  columns = [
    {
      showColumn: true,
      sortingColumn: '',
      key: 'truckNumber',
      header: 'Truck Number',
      sortable: false,
      viewDialog: true,
      type: 'text',
    },
    {
      showColumn: true,
      sortingColumn: '',
      key: 'truckModel',
      header: 'Truck Model',
      sortable: false,
      type: 'text',
      viewDialog: false,
    },

    {
      showColumn: true,
      sortingColumn: '',
      key: 'truckBrand',
      header: 'Truck Brand',
      sortable: false,
      type: 'text',
    },
    {
      showColumn: true,
      sortingColumn: '',
      key: 'associatedTyres',
      header: 'Horse TYRES',
      sortable: false,
      type: 'text',
    },
    {
      showColumn: true,
      sortingColumn: '',
      key: 'associatedTrailerTyres',
      header: 'Trailer TYRES',
      sortable: false,
      type: 'text',
    },
    {
      showColumn: true,
      sortingColumn: '',
      key: 'associatedBatteries',
      header: 'Battery',
      sortable: false,
      type: 'text',
    },
    {
      showColumn: true,
      sortingColumn: '',
      key: 'puc',
      header: 'Puc',
      sortable: false,
      type: 'text',
    },
    {
      showColumn: true,
      sortingColumn: '',
      key: 'status',
      header: 'Status',
      sortable: false,
      viewDialog: false,
      type: 'status',
    },
    {
      showColumn: true,
      sortingColumn: '',
      key: 'insuranceNumber',
      header: 'Insurance Number',
      sortable: false,
      type: 'text',
    },
    {
      showColumn: true,
      sortingColumn: '',
      key: 'vendorName',
      header: 'vendor',
      sortable: false,
      type: 'text',
    },
 
    {
      showColumn: true,
      sortingColumn: 'createdAt',
      key: 'createdAt',
      header: 'Created At',
      sortable: true,
      type: 'date',
    },
    {
      showColumn: true,
      sortingColumn: 'updatedAt',
      key: 'updatedAt',
      header: 'Updated At',
      sortable: true,
      type: 'date',
    },
  ];

  columnsToExport: string[] = [
    'financialYearId',
    'budgetDate',
    'budgetType',
    'reference',
    'accountName',
    'warehouseName',
    'approvedBudget',
    'expense',
    'createdAt',
    'createdByName',
    'updatedAt',
    'updatedByName',
    'budgetProof',
    'remarks',
  ];

  dropdownOptions: { [key: number]: string[] } = {
    0: ['2023-2024', '2022-2023'],
    1: ['January', 'February', 'March'],
  };

  warehouseList = []; // Define warehouse list here
  accounts = []; // Define account list here
  totalCount: any;
  @ViewChild(DownloadExcelComponent) downloadExcel!: DownloadExcelComponent;
  @ViewChild(CommonBulkPrintComponent) printData!: CommonBulkPrintComponent;
  @ViewChild(CommonCsvComponent) downloadCsv!: CommonCsvComponent;

  selectedRows: any[] = [];
  tableLists: any = [];
  user_details: any;
  dashboardLedger: any;
  totalTruck: any;
  liveTruck: any;
  draftTruck: any;
  complianceAlert: any;
  selectedCard: string = 'live';
  constructor(
    private ordersService: ordersService,
    private primengConfig: PrimeNGConfig,
    private fb: FormBuilder,
    private tabService: TabService,
    public dialogService: DialogService,
    private messageService: MessageService,
    private router: Router,
    public accessControlService: AccessControlService,
  ) {
    this.getWarehouseList = JSON.parse(localStorage.getItem('wareHouseList')!);
    this.accounts = JSON.parse(localStorage.getItem('accountList')!);
    this.user_details = JSON.parse(localStorage.getItem('UserDetails')!);
    this.userType = this.user_details?.userType;
    this.primengConfig.ripple = true;
  }

  searchForm = this.fb.group({
    WAREHOUSE_ID_IN: new FormControl(''),
    ACCOUNT_ID_IN: new FormControl(''),
    // FC_NAME: new FormControl(''),
    STATUS: new FormControl(null),
  });

  ngOnInit(): void {
    this.getdashboardLedger();
    this.truckFilter('tottal');
  }

  getdashboardLedger() {
    this.ordersService.dashboardLedger().subscribe((res: any) => {
      this.dashboardLedger = res?.responseObject;
      let data = res.responseObject;

      this.totalTruck =
        data.find((x: any) => x.name === 'Total Truck')?.count || 0;
      this.liveTruck =
        data.find((x: any) => x.name === 'Live Truck')?.count || 0;
      this.draftTruck =
        data.find((x: any) => x.name === 'Draft Truck')?.count || 0;
      this.complianceAlert =
        data.find((x: any) => x.name === 'Compliance Alert')?.count || 0;
      // this.totalCount = res?.responseObject?.totalElements;
    });
  }

  truckFilter(type: any) {
    this.selectedCard = type;
    let nameMap: any = {
      tottal: 'Total Truck',
      live: 'Live Truck',
      drafts: 'Draft Truck',
      compliance: 'Compliance Alert',
    };
    const selected = this.dashboardLedger.find(
      (x: any) => x.name === nameMap[type],
    );
    const truckIds = selected?.truckIds || '';
    let postData: any[] = [];

    if (truckIds && truckIds.trim() !== '') {
      postData.push({
        key: 'TRUCK_BUILD_ID_IN',
        value: truckIds,
      });
    }
    if (type === 'live') {
      postData.push({
        key: 'STATUS_IN',
        value: 'Running',
      });
    }

    // Draft filter
    if (type === 'drafts') {
      postData.push({
        key: 'STATUS_IN',
        value: 'Draft',
      });
    }
    this.filters = postData;
    if (selected?.name === 'Compliance Alert' && selected?.count === 0) {
      this.tableLists = [];
    } else {
      this.getList();
    }
  }

  reloadEvent(event: any) {
    console.log(event);
    // this.getList()
  }

  getList() {
    let postData: any[] = [];
    let vendorIds: string[] = [];
    let accountIds: any;
    this.filters = [...(this.filters || []), ...postData];
    this.filters = this.filters.filter(
      (item: any) =>
        (item.value && item.value.toString().trim() !== '') ||
        (item.dateValue && item.dateValue.toString().trim() !== ''),
    );
    this.tableLists = [];
    this.ordersService
      .getTruckBuild(
        this.filters,
        this.pageNumber,
        this.pageSize,
        this.sortingCol,
        this.direction,
      )
      .subscribe(
        (data: any) => {
          if (data) {
            this.tableLists = data?.responseObject?.content;
            this.totalCount = data?.responseObject?.totalElements;
            this.selectedData = [];
          }
        },
        (err) => {
          this.totalCount = 0;
          this.tableLists = [];
        },
      );
  }

  getListExportApi = (params: any): Observable<any> => {
    const {
      filters = {},
      pageNumber = 0,
      pageSize = 250,
      sortingCol = 'id',
      direction = 'DESC',
    } = params;

    return this.ordersService.getTruckBuild(
      filters,
      pageNumber,
      pageSize,
      sortingCol,
      direction,
    );
  };

  onFilterChange(event: any) {
    if (event) {
      console.log(event);
      this.filters = event;
      this.getList();
    }
  }

  onResetFilters() {
    this.filters = [];
    this.getList();
  }

  paginate(event: any) {
    this.pageNumber = event.pageIndex;
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getList();
  }

  onSortChange(event: { columnKey: string; sortOrder: 'ASC' | 'DESC' }): void {
    this.sortingCol = event.columnKey;
    this.direction = event.sortOrder;
    this.getList();
  }

  onSelectedRowsChange(selectedRows: any[]) {
    const storedData = JSON.parse(
      localStorage.getItem('columnToExport') || '{}',
    );

    this.columnsToExport = storedData['budget'] ?? this.columnsToExport;

    this.selectedRows = selectedRows;
    this.selectedData = selectedRows;

    if (this.downloadExcel) {
      this.downloadExcel.data = [...selectedRows];
    } else {
      console.error('DownloadExcelComponent is not initialized.');
    }
  }

  addBudget(type: any) {
    console.log(type,'ppppppppp')
    // this.ref = this.dialogService.open(AddordersComponent, {
    this.ref = this.dialogService.open(NeAddOrderComponent, {
      // header: `${type} Order`,
      header: type == 'Edit' ? 'Edit':'Assemble Truck',
      data:
        type == 'Edit' ? {
            editData: this.selectedRows,
            edit: this.editContation
        }
        : {
            editData: this.selectedData,
            edit: this.editContation,
          },
      width: '90vw',
      contentStyle: { overflow: 'auto', position: 'top' },
      draggable: true,
      styleClass: 'no-close-icon-dialog',
    });
    this.ref.onClose.subscribe((data: any) => {
      console.log('resss', data);
      if (data) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: data?.responseMessage,
        });
      }
      this.getList();
    });
  }

  receiveDataEvent(data: any[]) {
    console.log(data);
    this.selectedData = data;
  }
  editEvent() {
    this.editContation = true;
    // console.log(this.editContation);
    // this.addBudget('Edit');
    // console.log(this.selectedRows[0])
    this.editTruck(this.selectedRows[0])
  }
  deleteEvent() {
    // const ids = Array.from(new Set(this.selectedData.map((item: any) => item.id))).join(',');
    // this.masterServices.deleteExpense(ids).subscribe((data: any) => {
    //   if(data){
    //     this.selectedData = [];
    //     this.getList();
    //     this.messageService.add({
    //       severity: 'success',
    //       summary: 'Success',
    //       detail: 'Expense Deleted successfully',
    //     });
    //   }
    //  },err => {
    //   this.tableLists = []
    //  });
  }

  duplicateEvent() {
    console.log(this.selectedData);
    const payload = {
      expenseCategoryId: this.selectedData[0].expenseCategoryId,
      expenseModeId: this.selectedData[0].expenseModeId,
      expenseName: this.selectedData[0].expenseName,
      status: this.selectedData[0].status,
    };
    //  this.masterServices.expenseAddOrUpdate(payload).subscribe((data: any) => {
    //   if(data){
    //    this.messageService.add({
    //      severity: 'success',
    //      summary: 'Success',
    //      detail: 'Expense added successfully',
    //    });
    //    this.getList();
    //    this.selectedData = [];
    //   }
    //  });
  }

  upload(url: any, params: any) {
    this.tabService.addTab({
      label: 'Upload',
      path: url,
      fullPath: '',
      filterData: [],
      // pageNumber: 0,
      // pageSize: 10
    });
    this.router.navigate([url], { queryParams: params });
  }

  openDetail(id: any) {
    this.tabService.addTab({
      label: 'Truck Mapping',
      path: `/truck-mapping/truck-details/${id}`,
      fullPath: '',
      filterData: [],
      // pageNumber: 0,
      // pageSize: 10
    });
    this.router.navigate(['/truck-mapping/truck-details/' + id]);
  }

  sortData(key: string) {
    // this.sortingCol, this.direction
    if (this.sortingCol === key) {
      this.direction = this.direction === 'ASC' ? 'DESC' : 'ASC';
    } else {
      this.sortingCol = key;
      this.direction = 'ASC';
    }
    this.getList();
  }
  onRowSelect(row: any) {
    if (row) {
      this.selectedRows = [];
      this.selectedRows.push(row);
    }
    if (row.selected) {
      this.selectedRows = this.tableLists.filter((r: any) => r.selected);
    } else {
      this.selectedRows = this.selectedRows.filter((r) => r !== row);
    }
    console.log(this.selectedRows);

    // this.isAllSelected = this.data.every(r => r.selected);
    // this.selectedRowsChange.emit(this.selectedRows);
  }

  addComponentPopUp() {
    this.ref = this.dialogService.open(AddComponentComponent, {
      // header: `${type} Order`,
      header: `Add Component`,
      data: {
        data: this.selectedRows[0],
        // edit: this.editContation
      },
      width: '50vw',
      contentStyle: { overflow: 'auto', position: 'top' },
      draggable: true,
      styleClass: 'no-close-icon-dialog',
    });
    this.ref.onClose.subscribe((data: any) => {
      console.log('resss', data);
      if (data) {
        // this.messageService.add({
        //   severity: 'success',
        //   summary: 'Success',
        //   detail: data?.responseMessage,
        // });
      }
      this.getList();
      this.getdashboardLedger();
      this.selectedRows = [];
    });
  }

  removeComponentPopUp() {
    this.ref = this.dialogService.open(RemoveComponentComponent, {
      header: `Remove Component`,
      data: {
        data: this.selectedRows[0],
      },
      width: '55vw',
      contentStyle: { overflow: 'auto', position: 'top' },
      draggable: true,
      styleClass: 'no-close-icon-dialog',
    });
    this.ref.onClose.subscribe((data: any) => {
      console.log('resss', data);
      if (data) {
        // this.messageService.add({
        //   severity: 'success',
        //   summary: 'Success',
        //   detail: data?.responseMessage,
        // });
      }
      this.getList();
      this.getdashboardLedger();
      this.selectedRows = [];
    });
  }



  
editTruck(item:any){
 // this.ref = this.dialogService.open(AddordersComponent, {
    this.ref = this.dialogService.open(NeAddOrderComponent, {
      // header: `${type} Order`,
      header: `Edit Assemble Truck`,
      data: {
        editData: item,
        edit: true
      },
      width: '90vw',
      contentStyle: { overflow: 'auto', position: "top" },
      draggable: true,
      styleClass: 'no-close-icon-dialog',
    });
    this.ref.onClose.subscribe((data: any) => {
      console.log("resss", data)
      this.selectedRows=[]
      if (data) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: data?.responseMessage,
        });
      }
      this.getList()
      this.getdashboardLedger();
    });
}

exchangeComponentPopUp() {
  this.ref = this.dialogService.open(ExchangeComponentComponent, {
    // header: `${type} Order`,
    header: `Exchange Component`,
    data: {
      data: this.selectedRows[0],
      // edit: this.editContation
    },
    width: '50vw',
    contentStyle: { overflow: 'auto', position: 'top' },
    draggable: true,
    styleClass: 'no-close-icon-dialog',
  });
  this.ref.onClose.subscribe((data: any) => {
    console.log('resss', data);
    if (data) {
      // this.messageService.add({
      //   severity: 'success',
      //   summary: 'Success',
      //   detail: data?.responseMessage,
      // });
    }
    this.getList();
    this.selectedRows = [];
  });
}

}
